export default function SectionContact() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/25 mb-6">
            <i className="ri-mail-send-line text-accent-400 text-sm"></i>
            <span className="text-xs font-medium text-accent-400 whitespace-nowrap">意见反馈</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">联系我们</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 leading-relaxed">
            如果您在使用91精品影视过程中遇到任何问题，或有资源投稿、合作意向，
            欢迎通过以下方式与我们取得联系。我们重视每一位用户的反馈，将持续优化在线看片体验。
          </p>
          <div className="mt-8 p-6 rounded-xl bg-background-200/70 border border-background-300/30">
            <div className="flex items-center justify-center gap-3 text-foreground-200">
              <div className="w-10 h-10 rounded-full bg-primary-500/15 flex items-center justify-center">
                <i className="ri-mail-line text-primary-400 text-lg"></i>
              </div>
              <span className="text-sm md:text-base font-medium">service@91jingpin.vip</span>
            </div>
            <p className="mt-3 text-xs text-foreground-500">
              我们会在24小时内回复您的邮件
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}